import React, { useState } from 'react';
import { FAVICON_TALKU } from './logos';
import ProfileMenu from './ProfileMenu';
import NotificationPanel from './NotificationPanel';

const SF = `'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`;

const IcoDashboard  = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?'#fff':'#ccc'} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>;
const IcoChat       = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?'#fff':'#ccc'} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IcoBox        = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?'#fff':'#ccc'} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>;
const IcoUsers      = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?'#fff':'#ccc'} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoFlow       = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?'#fff':'#ccc'} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>;
const IcoMega       = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?'#fff':'#ccc'} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>;
const IcoCampaign   = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?'#fff':'#ccc'} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg>;
const IcoSettings   = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?'#fff':'#9ca3af'} strokeWidth="1.9" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>;
const IcoVideo      = ({a}) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?'#fff':'#ccc'} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="14" height="14" rx="2.5"/><path d="M16 10l6-3v10l-6-3z"/></svg>;
const IcoBell       = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.9" strokeLinecap="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
const IcoHelp       = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.9" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;

const NAV_ITEMS = [
  { id:'Dashboard',      label:'Dashboard',      Icon:IcoDashboard },
  { id:'Conversaciones', label:'Conversaciones',  Icon:IcoChat },
  { id:'Pedidos',        label:'Pedidos',         Icon:IcoBox },
  { id:'Contactos',      label:'Contactos',       Icon:IcoUsers },
  { id:'Flujos',         label:'Flujos',          Icon:IcoFlow },
  { id:'Marketing',      label:'Marketing',       Icon:IcoMega },
  { id:'Campañas',       label:'Campañas',        Icon:IcoCampaign },
  { id:'Video IA',       label:'Video IA',        Icon:IcoVideo },
  { id:'Configuraciones',label:'Configuraciones', Icon:IcoSettings },
];

export default function Layout({ user, activeNav, onNav, onLogout, children }) {
  const [showNotifs, setShowNotifs] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  const handleNav = (id) => { setMobileMenu(false); if (onNav) onNav(id); };

  return (
    <>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        html, body {
          overflow: hidden;
          font-family: ${SF};
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        /* ── Root ── */
        .lyt-root { display: flex; flex-direction: column; height: 100vh; overflow: hidden; background: #f5f5f3; }

        /* ── Top bar ── */
        .lyt-topbar {
          height: 52px;
          background: #f5f5f3;
          border-bottom: 1px solid #e5e7eb;
          display: flex; align-items: center;
          padding: 0 20px;
          flex-shrink: 0; z-index: 200;
          gap: 16px;
          animation: lyt-slideDown .35s cubic-bezier(.4,0,.2,1) both;
        }

        /* Brand */
        .lyt-brand {
          display: flex; align-items: center; gap: 10px; flex-shrink: 0;
          padding-right: 16px; border-right: 1px solid #e0e0de;
          margin-right: 4px;
        }
        .lyt-brand-logo {
          width: 28px; height: 28px; border-radius: 50%;
          background: #fff; border: 1px solid #e5e7eb;
          display: flex; align-items: center; justify-content: center;
          overflow: hidden; flex-shrink: 0;
          transition: transform .2s;
        }
        .lyt-brand-logo:hover { transform: scale(1.08) rotate(5deg); }
        .lyt-brand-logo img { width: 20px; height: 20px; object-fit: contain; }
        .lyt-brand-name {
          font-size: 14px; font-weight: 700; color: #0d0d0d;
          letter-spacing: -.2px; white-space: nowrap;
        }
        .lyt-brand-sep {
          width: 1px; height: 16px; background: #d4d4d4; margin: 0 2px;
        }
        .lyt-brand-sub {
          font-size: 13px; font-weight: 400; color: #9ca3af;
          white-space: nowrap; letter-spacing: -.1px;
        }

        /* Nav pill container */
        .lyt-nav-pill {
          display: flex; align-items: center;
          background: #1a1a1a;
          border-radius: 999px;
          padding: 3px 4px;
          gap: 1px;
          animation: lyt-pillGrow .4s cubic-bezier(.4,0,.2,1) .1s both;
        }

        .lyt-nav-item {
          display: flex; align-items: center; gap: 6px;
          padding: 6px 14px;
          border-radius: 999px;
          border: none; background: transparent;
          font-family: inherit; font-size: 12.5px; font-weight: 500;
          color: #999; cursor: pointer;
          transition: all .2s cubic-bezier(.4,0,.2,1);
          white-space: nowrap; position: relative;
        }
        .lyt-nav-item:hover { color: #ddd; background: rgba(255,255,255,.08); }
        .lyt-nav-item.is-active {
          color: #fff; background: rgba(255,255,255,.15);
          font-weight: 700;
        }
        .lyt-nav-item.is-active::after {
          content: ''; position: absolute; bottom: 2px; left: 50%; transform: translateX(-50%);
          width: 16px; height: 2px; border-radius: 1px; background: #88da21;
          animation: lyt-dotGrow .25s ease both;
        }
        .lyt-nav-ico { display: flex; align-items: center; flex-shrink: 0; }

        /* Separator line inside pill */
        .lyt-nav-sep {
          width: 1px; height: 18px; background: rgba(255,255,255,.1);
          flex-shrink: 0; margin: 0 2px;
        }

        /* More button (mobile overflow) */
        .lyt-nav-more {
          display: none; align-items: center; justify-content: center;
          width: 32px; height: 32px; border-radius: 50%;
          background: transparent; border: none; cursor: pointer;
          color: #999; font-size: 18px; font-weight: 700;
          transition: background .15s;
        }
        .lyt-nav-more:hover { background: rgba(255,255,255,.08); }

        /* Right side */
        .lyt-right {
          display: flex; align-items: center; gap: 6px;
          margin-left: auto; flex-shrink: 0;
        }
        .lyt-tb-btn {
          width: 34px; height: 34px; border-radius: 50%;
          border: 1px solid #e5e7eb; background: #fff;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; flex-shrink: 0;
          transition: background .15s, transform .2s, box-shadow .2s;
          animation: lyt-fadeIn .3s ease .2s both;
        }
        .lyt-tb-btn:hover { background: #f0f0ee; transform: scale(1.06); box-shadow: 0 2px 8px rgba(0,0,0,.06); }

        /* Mobile hamburger */
        .lyt-hamburger {
          display: none; width: 34px; height: 34px; border-radius: 8px;
          background: transparent; border: 1px solid #e5e7eb;
          align-items: center; justify-content: center;
          cursor: pointer; color: #9ca3af; flex-shrink: 0;
        }
        .lyt-hamburger:hover { background: #fff; }

        /* Mobile menu */
        .lyt-mobile-menu {
          display: none; position: fixed; top: 52px; left: 0; right: 0;
          background: #1a1a1a; z-index: 199;
          padding: 8px 12px; border-bottom: 1px solid #333;
          animation: lyt-slideDown .25s ease both;
        }
        .lyt-mobile-menu .lyt-nav-item {
          width: 100%; justify-content: flex-start; padding: 10px 14px;
          font-size: 14px;
        }

        .lyt-overlay {
          position: fixed; inset: 0; top: 52px;
          background: rgba(0,0,0,.5); z-index: 198;
          animation: lyt-fadeIn .2s ease;
        }

        @media (max-width: 900px) {
          .lyt-nav-pill { display: none; }
          .lyt-hamburger { display: flex; }
          .lyt-mobile-menu.is-open { display: flex; flex-direction: column; }
          .lyt-brand-sub, .lyt-brand-sep { display: none; }
        }

        /* ── Content ── */
        .lyt-content {
          flex: 1; display: flex; flex-direction: column;
          overflow: hidden; min-width: 0;
          position: relative;
        }

        /* Page transition wrapper */
        .lyt-page {
          flex: 1; display: flex; flex-direction: column;
          overflow: hidden; min-width: 0;
          animation: lyt-pageIn .45s cubic-bezier(.4,0,.2,1) both;
        }

        /* Progress bar */
        .lyt-progress {
          position: absolute; top: 0; left: 0; right: 0;
          height: 2.5px; z-index: 50; overflow: hidden;
          pointer-events: none;
        }
        .lyt-progress-bar {
          height: 100%;
          background: linear-gradient(90deg, transparent, #88da21 30%, #6ee7b7 70%, #88da21);
          border-radius: 0 2px 2px 0;
          animation: lyt-progressRun .5s cubic-bezier(.4,0,.2,1) both;
          box-shadow: 0 0 8px rgba(136,218,33,.4), 0 0 2px rgba(136,218,33,.6);
        }

        /* Shimmer overlay */
        .lyt-shimmer {
          position: absolute; inset: 0; z-index: 40;
          pointer-events: none;
          background: linear-gradient(
            110deg,
            transparent 30%,
            rgba(136,218,33,.03) 45%,
            rgba(136,218,33,.06) 50%,
            rgba(136,218,33,.03) 55%,
            transparent 70%
          );
          background-size: 250% 100%;
          animation: lyt-shimmerSlide .6s ease both;
        }

        /* Animations */
        @keyframes lyt-slideDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes lyt-pillGrow { from { opacity: 0; transform: scaleX(.85); } to { opacity: 1; transform: scaleX(1); } }
        @keyframes lyt-dotGrow { from { width: 0; } to { width: 16px; } }
        @keyframes lyt-fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes lyt-avatarPop { from { opacity: 0; transform: scale(.6); } to { opacity: 1; transform: scale(1); } }
        @keyframes lyt-fade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes lyt-pageIn {
          0%   { opacity: 0; transform: translateY(10px) scale(.995); filter: blur(3px); }
          60%  { opacity: 1; filter: blur(0); }
          100% { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); }
        }
        @keyframes lyt-progressRun {
          0%   { width: 0; }
          40%  { width: 65%; }
          80%  { width: 90%; }
          100% { width: 100%; opacity: 0; }
        }
        @keyframes lyt-shimmerSlide {
          0%   { background-position: 150% 0; opacity: 1; }
          100% { background-position: -50% 0; opacity: 0; }
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        .spinner {
          width: 16px; height: 16px;
          border: 2px solid #e5e7eb; border-top-color: #6ee7b7;
          border-radius: 50%; animation: spin .7s linear infinite;
          display: inline-block;
        }
      `}</style>

      {mobileMenu && <div className="lyt-overlay" onClick={() => setMobileMenu(false)}/>}

      <div className="lyt-root">

        {/* ══════════ TOP BAR ══════════ */}
        <header className="lyt-topbar">

          {/* Hamburger (mobile) */}
          <button className="lyt-hamburger" onClick={() => setMobileMenu(v => !v)}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>

          {/* Brand */}
          <div className="lyt-brand">
            <div className="lyt-brand-logo">
              <img src={FAVICON_TALKU} alt="Talku"/>
            </div>
            <span className="lyt-brand-name">Talku</span>
            <div className="lyt-brand-sep"/>
            <span className="lyt-brand-sub">CRM</span>
          </div>

          {/* Nav pill */}
          <nav className="lyt-nav-pill">
            {NAV_ITEMS.map(({ id, label, Icon }, i) => (
              <React.Fragment key={id}>
                {i === NAV_ITEMS.length - 1 && <div className="lyt-nav-sep"/>}
                <button
                  className={`lyt-nav-item${activeNav === id ? ' is-active' : ''}`}
                  onClick={() => handleNav(id)}
                >
                  <span className="lyt-nav-ico"><Icon a={activeNav === id}/></span>
                  {label}
                </button>
              </React.Fragment>
            ))}
          </nav>

          {/* Right */}
          <div className="lyt-right">
            <button className="lyt-tb-btn" onClick={() => setShowNotifs(v => !v)} title="Notificaciones">
              <IcoBell/>
            </button>
            <button className="lyt-tb-btn" title="Ayuda">
              <IcoHelp/>
            </button>
            <ProfileMenu user={user} onNav={onNav} onLogout={onLogout}/>
          </div>
        </header>

        {/* Mobile nav dropdown */}
        <div className={`lyt-mobile-menu${mobileMenu ? ' is-open' : ''}`}>
          {NAV_ITEMS.map(({ id, label, Icon }) => (
            <button
              key={id}
              className={`lyt-nav-item${activeNav === id ? ' is-active' : ''}`}
              onClick={() => handleNav(id)}
            >
              <span className="lyt-nav-ico"><Icon a={activeNav === id}/></span>
              {label}
            </button>
          ))}
        </div>

        {/* ══════════ CONTENT ══════════ */}
        <main className="lyt-content">
          <div className="lyt-progress" key={`prog-${activeNav}`}>
            <div className="lyt-progress-bar"/>
          </div>
          <div className="lyt-shimmer" key={`shim-${activeNav}`}/>
          <div className="lyt-page" key={activeNav}>
            {children}
          </div>
        </main>

        {showNotifs && <NotificationPanel onClose={() => setShowNotifs(false)}/>}
      </div>
    </>
  );
}
